import React, { useState } from "react";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { AiOutlineCalendar } from "react-icons/ai";
import { format, addDays, isSameDay } from "date-fns";
import { pl } from "date-fns/locale";
import EAIconButton from "../../../shared/Buttons/EAIconButton";
import EAButton from "../../../shared/Buttons/EAButton";
import EACalendarModal from "../../../shared/CalendarModal/EACalendarModal";
import useMediaQuery from "@mui/material/useMediaQuery";
import useAttractionsCalendar from "../../../CourtGrid/hooks/useAttractionsCalendar";
import useFacility from "../../../../../utils/hooks/useFacility";
import "./style.scss";

interface IProps {
  startDate: Date;
  onPreviousPeriod: () => void;
  onNextPeriod: () => void;
  onDateChange?: (date: Date) => void;
  courtName: string;
}

const WeeklyGridBar: React.FC<IProps> = ({ startDate, onPreviousPeriod, onNextPeriod, onDateChange, courtName }) => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const isMobile = useMediaQuery("(max-width: 980px)");
  const facilityIds = useFacility();
  const { unavailableDates } = useAttractionsCalendar(facilityIds, courtName);
  const today = new Date();
  const isPastDate = isMobile ? startDate < today && !isSameDay(startDate, today) : startDate < today;

  const getDateRangeLabel = () => {
    if (isMobile) {
      // Mobile: pojedynczy dzień
      return format(startDate, "dd MMM", { locale: pl });
    } else {
      // Desktop: zakres tygodnia
      const endDate = addDays(startDate, 6);
      return `${format(startDate, "dd.MM")} - ${format(endDate, "dd.MM.yyyy")}`;
    }
  };

  const getPreviousTooltip = () => {
    return isMobile ? "Poprzedni dzień" : "Poprzedni tydzień";
  };

  const getNextTooltip = () => {
    return isMobile ? "Następny dzień" : "Następny tydzień";
  };

  const handleDateChange = (date: Date) => {
    if (onDateChange) {
      onDateChange(date);
    }
    setOpenCalendar(false);
  };

  return (
    <>
      <div className="weekly-grid-bar">
        <div className="weekly-grid-bar__navigation">
          <EAIconButton
            title={getPreviousTooltip()}
            icon={<MdOutlineKeyboardArrowLeft />}
            variant="outlined"
            onClick={onPreviousPeriod}
            disabled={isPastDate}
          />

          <EAButton
            title={getDateRangeLabel()}
            endIcon={<AiOutlineCalendar />}
            variant="outlined"
            onClick={() => setOpenCalendar(true)}
          />

          <EAIconButton
            title={getNextTooltip()}
            icon={<MdOutlineKeyboardArrowRight />}
            variant="outlined"
            onClick={onNextPeriod}
          />
        </div>
      </div>

      {openCalendar && (
        <EACalendarModal
          onClose={() => setOpenCalendar(false)}
          onDatePick={handleDateChange}
          date={startDate}
          title="Wybór tygodnia"
          unavailableDays={unavailableDates}
        />
      )}
    </>
  );
};

export default WeeklyGridBar;
